module.exports = __webpack_public_path__ + "static/media/particion_bicicleta.b9963bf3.PNG";